module.exports = __webpack_public_path__ + "static/img/s3.1ff51c8f.jpg";